import React from 'react';
import AdminQuizPage from '../../body/AdminQuizPage';
import { ADMIN_QUIZ_MODULES } from '../../../../apis/quiz';

const introContent = (
  <div className='space-y-4 text-left'>
    <div>
      <p className='text-xl leading-relaxed'>
        <b>Instructions:</b> Answer the following questions by choosing the one
        best answer. A score of <b>80%</b> is required to move on to the next
        training module.
      </p>
    </div>
  </div>
);

const Mod2Quiz = () => (
  <AdminQuizPage
    moduleKey={ADMIN_QUIZ_MODULES.strategiesPart1}
    title='End of Module Test'
    introContent={introContent}
    pdfSrc='/resource-library/mod2/PROGRAM-PARENTING-STRATEGIES.pdf'
    pdfText='Program Strategies Part 1 and 2'
  />
);

export default Mod2Quiz;

